import React, { useEffect, useState } from "react";
import { Header } from "../components/common/Header";
import { StoreCard } from "../components/common/StoreCard";
import { getBooks } from "../api/getBooks";
import Footer from "../components/common/Footer";
import backgroundImage from "../assets/img/butik.png";

// 1) Import the new CSS file
import "./Store.css";

export const Store = () => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    const getallbooks = async () => {
      let { data } = await getBooks();
      setBooks(data);
    };
    getallbooks();
  }, []);

  return (
    <div className="store-container">
      <Header active={4} />

      <main className="store-hero">
        {/* Semi-transparent overlay */}
        <span className="store-overlay"></span>

        {/* Hero content */}
        <div className="store-hero-content">
          <h1 className="store-hero-title">Böcker</h1>
          <p className="store-hero-subtitle">
            Här kan du handla bland våra böcker.
          </p>
        </div>
      </main>

      <div className="store-grid">
        {books.map((EachBook, key) => (
          <StoreCard book={EachBook} key={key} />
        ))}
      </div>

      <Footer />
    </div>
  );
};
